import { Set } from '~commonInfra/utils/Set';

import { Messages } from '../../codegen/Localize';
import { ActionHelpers, standardActionErrorMsg, standardActionSuccessMsg } from '../../commonInfra/contentActions/ActionHelpers';
import { IErrorItem } from '../../commonInfra/contentActions/MultipleItemResult';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { FlowBaseInfo } from '../models/FlowInfo';
import { Flows } from '../resources/Flows';
import { FlowErrors } from '../services/FlowErrors';

export namespace ChangeFlowDescriptionAction {
  export function execute(flow: FlowBaseInfo, newDescription: string): Promise<IResult> {
    return Flows.setDescription(flow.id, newDescription).then((result: IResult) => {
        ActionHelpers.displayStandardToastsForResult(
          Set.singletonForIdItem(flow),
          result,
          {
            success: standardActionSuccessMsg(Messages.editDescriptionSuccessful),
            error: standardActionErrorMsg(Messages.editDescriptionFailure),
          },
          (errorItem: IErrorItem<FlowBaseInfo>) => FlowErrors.errorDetailsFor(errorItem)
        );
        return result;
    });
  }
}
